import { produce } from 'immer';
import { setAuth } from '../../services/AuthService';

const initialState = {};

// Some selectors.
export const selectPatientId = ({ session }) => session?.userSession?.patientId;
export const selectUserId = ({ session }) => session?.userSession?.userId;
export const selectProfile = ({ session }) => session?.profile || {};
export const selectProfileFailure = ({ session }) => session?.profileFailure || {};
export const selectUiMode = ({ session }) =>
  session?.profile?.uiMode || session?.userSession?.extraFields?.uiMode || 'LIGHT';
export const selectHiddenCards = ({ session }) => session?.profile?.hiddenCards || '';
export const selectStudyCode = ({ session }) => session?.profile?.studyCode || '';

export const SET_USER_SESSION = 'SET_USER_SESSION';
export const setSession = (session) => ({
  type: SET_USER_SESSION,
  payload: { ...session },
});

export const SET_PROFILE = 'SET_PROFILE';
export const setProfile = (profile) => ({
  type: SET_PROFILE,
  payload: {
    ...profile,
  },
});

export const CLEAR_PROFILE_FAILURE = 'CLEAR_PROFILE_FAILURE';
export const clearProfileFailure = () => ({
  type: CLEAR_PROFILE_FAILURE,
});

export const SET_PROFILE_FAILURE = 'SET_PROFILE_FAILURE';
export const setProfileFailure = (error) => ({
  type: SET_PROFILE_FAILURE,
  payload: {
    ...error,
  },
});

const session = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type, payload } = action;
    switch (type) {
      case SET_USER_SESSION:
        draft.userSession = payload;
        break;
      case SET_PROFILE:
        draft.profile = {
          language: payload.language,
          uiMode: payload.uiMode,
          isEmailReminder: payload.isEmailReminder?.toString(), // Need the string value of these booleans for MUI
          isTextReminder: payload.isTextReminder?.toString(),
          nickname: payload.nickname,
          phone: payload.phone,
          province: payload.province,
          birthYear: payload.birthYear,
          email: payload.email,
          studyCode: payload.studyCode,
          hiddenCards: payload.hiddenCards,
        };
        draft.userSession = {
          ...draft.userSession,
          extraFields: {
            uiMode: payload.uiMode,
          },
        };
        setAuth(JSON.stringify(draft.userSession));
        break;
      case SET_PROFILE_FAILURE:
        draft.profileFailure = payload;
        break;
      case CLEAR_PROFILE_FAILURE:
        draft.profileFailure = {};
        break;
      default:
        break;
    }
  });

export default session;
